module.exports = {
    title: "开箱扫码_惠合科技数字营销方案_铺货营销、奖励实时发放",
    description: "基于“一物一码”技术，惠合科技“开箱扫码”方案代替了传统的搭赠或折价铺货方式，在保障价格稳定的基础上提升商品进货率、开箱率和上架率。",
    keywords: "开箱扫码,一物一码,扫码活动,铺货方案,铺货促销"
}